module.exports = {
      id: "slider-arrow-usage",
      viewBox: "0 0 24 46",
      url: __webpack_public_path__ + "sprite.svg#slider-arrow-usage",
      toString: function () {
        return this.url;
      }
    }